
























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import NewPdfForm from './pdfForm/NewPdfForm.vue';
import LeftPanel from './pdfForm/leftPanelComponents/LeftPanel.vue';
import type { DocumentItem } from '@/entities/document/model'
import _ from 'lodash';

@Component({
  name: 'PdfFormViewContainer',
  components: {
    LeftPanel,
    NewPdfForm,
  }
})
export default class PdfFormViewContainer extends Vue {
  participants: any[] = [] // TODO: участники подписания или в сторе или еще как то

  get sessionId() { return this.$route.params.id }
  get senderId() { return this.$route.params.uid }

  get documents() {
    return this.$store.state?.transaction?.documents || []
  }

  get currentSelectedDocument(): DocumentItem | null {
    return this.$store?.state?.currentDocument?.currentDocument || this.documents?.[0] || null
  }

  getCurrentStepComponent() {
    return NewPdfForm
  }
}
